'use strict';/* global define:false */define('modules/users/services/password-factory/index',['require'],function(require){'use strict';// @ngInject
model.$inject = ["$resource", "API_ENDPOINT"];
function model($resource,API_ENDPOINT){var url=API_ENDPOINT;var params={};var actions={set:{method:'POST',url:url+'change-password'}};return $resource(url,params,actions);}return model;});
